const cefSharpInvalidErrorPattern = /^Object Not Found Matching Id:\d+, MethodName:[^,\s]+, ParamCount:\d+$/;
const nonErrorUnhandledRejectionMessage = 'unhandledrejection handler received a non-error. See "unhandledrejection handler" tab for more detail.';
export function isCefSharpInvalidError(event) {
  const error = event.errors?.[0];
  if (error?.errorClass !== "InvalidError" || error.errorMessage !== nonErrorUnhandledRejectionMessage) {
    return false;
  }
  const nonErrorParameter = event.getMetadata("unhandledrejection handler", "non-error parameter");
  return typeof nonErrorParameter === "string" && cefSharpInvalidErrorPattern.test(nonErrorParameter);
}
